<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
          <div class="amej-title">
            <h1>Transfer Fund</h1>
          </div>
        </div>
      </div>
      <FundTransactionForm action-url="/transfer"></FundTransactionForm>
    </div>
  </div>
</template>

<script>
import AppHeader from "../reuseable_components/Header.vue";
import FundTransactionForm from "./FundTransactionForm.vue";

export default {
  name: "TransferFund",
  components: {
    "app-header": AppHeader,
    FundTransactionForm: FundTransactionForm,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
  @import '../../css/style.scss';
</style>
